import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Home from './home';

export const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Home),
);
